// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#cd-configurator .spinner[data-v-20e59a3e] {\r\n  width: 5rem;\r\n  height: 5rem;\n}\r\n", ""]);
// Exports
module.exports = exports;
